import Http from '../../../http';
import { UPDATE_BRAND_SETTINGS } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const updateBrandSettings = (brandId, updateData) => dispatch =>
  Http.put(`/brand/${brandId}`, updateData)
    // api response will have addressId, not the whole address,
    // so we refetch with address
    .then(() => Http.get(`/brand/${brandId}?include=address`))
    .then((brand) => {
      dispatch({
        type: UPDATE_BRAND_SETTINGS,
        brand,
      });
      return brand;
    });
